import React, {useEffect, useRef, useState, useCallback} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Container, Modal, Row, Button, Spinner } from 'react-bootstrap';
import '../../assets/Styles/SimulationCSS/SliderSim.css';

const MTS_Stops = ({title, latlng, _isChecked}) => {
    const [selectedSavedCitiesOption, setSelectedSavedCitiesOption] = useState('');
    const [isChecked, setIsChecked] = useState(_isChecked || false);
    const handleSavedCitites = (event) => {};

    useEffect(() => {
        // Check if the label has data-lat-lng attribute
        if (latlng) {
            setIsChecked(true);
        }
    }, [latlng]);

    useEffect(() => {
        setIsChecked(_isChecked);
    }, [_isChecked])

    const handleCheckboxChange = () => {
        setIsChecked(true);
        // Optionally, you can call a parent callback here to notify the parent component of the change
    };

    return (
        <div id="MTS_Stops_Card">
            <div id="MTS_Stops_Card_Title">
                <input type="checkbox" id="card-checkbox" style={{ marginRight: '8px', accentColor: "#eba329" }} checked={isChecked} onChange={handleCheckboxChange}/>
                <label data-lat-lng={latlng} htmlFor={title}>{title}</label>
            </div>
        </div>
    );
};

export default MTS_Stops;